import { render, staticRenderFns } from "./knowledgeArea.vue?vue&type=template&id=a35811d2&scoped=true"
import script from "./knowledgeArea.vue?vue&type=script&lang=js"
export * from "./knowledgeArea.vue?vue&type=script&lang=js"
import style0 from "./knowledgeArea.vue?vue&type=style&index=0&id=a35811d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35811d2",
  null
  
)

export default component.exports